import React from 'react';

import { Main, DoneCard } from '@/components';

import styles from './available.module.scss';

const Available: React.FC = () => {
  const text = 'В рамках 1 договора с НДС и ЭДО в 155 городах';
  const cards = [
    { id: 1, text: '"Зеленый коридор" для записи на СТО' },
    {
      id: 2,
      text: 'Подбор и доставка запчастей перед приездом (или до приезда)'
    },
    { id: 3, text: 'Online согласование ремонта' },
    {
      id: 4,
      text: 'Online информирование обо всех изменениях в процессе ремонта'
    },
    { id: 5, text: 'Моментальная выдача' }
  ];

  return (
    <div className={styles.container}>
      <Main>
        <h2 className={styles.container__title}>
          В <span className={styles.container__title_info}>FIT SERVICE </span>
          доступно
        </h2>
        <p className={styles.container__text}>{text}</p>
        <div className={styles.container__cards}>
          {cards.map((card) => (
            <DoneCard
              key={card.id}
              className={styles.container__card}
              text={card.text}
            />
          ))}
        </div>
      </Main>
    </div>
  );
};

export default Available;
